import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormModule } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef, NzModalTitleDirective } from 'ng-zorro-antd/modal';
import { PackagingsService } from 'src/app/private/services/packagings.service';
import { PackagingDto } from 'src/app/shared/dto/packaging.dto';

@Component({
    selector: 'app-modal-edit-packaging-from-final-product',
    standalone: true,
    imports: [
        NzModalTitleDirective,
        NzModalFooterDirective,
        ReactiveFormsModule,
        NzFormDirective,
        NzRowDirective,
        NzFormItemComponent,
        NzColDirective,
        NzFormControlComponent,
        NzInputDirective,
        NzMessageModule,
        NzFormModule,
        NzButtonModule
    ],
    templateUrl: './modal-edit-packaging-from-final-product.component.html',
    styleUrl: './modal-edit-packaging-from-final-product.component.scss'
})
export class ModalEditPackagingFromFinalProductComponent implements OnInit {

    @Output() emitService = new EventEmitter();
    packaging: PackagingDto = new PackagingDto();
    validateForm: FormGroup<{
        quantity: FormControl<number>;
    }>;
    isSaving: boolean = false;

    readonly packagingsService = inject(PackagingsService);
    readonly toast = inject(NzMessageService);
    readonly fb = inject(NonNullableFormBuilder);
    readonly data = inject(NZ_MODAL_DATA);

    private readonly modalRef = inject(NzModalRef);

    constructor() {
        this.validateForm = this.fb.group({
            quantity: [0, [Validators.required, Validators.min(0)]]
        });
    }

    ngOnInit(): void {
        this.packaging = this.data?.packaging;
        this.validateForm.patchValue(this.data.packaging);
    }

    async submitForm(): Promise<void> {
        try {
            this.isSaving = true;

            if (!this.validateForm.valid) {
                this.isSaving = false;
                this.toast.error(`Porfavor, rellene los campos obligatorios`);
                return;
            }

            this.packaging.quantity = this.validateForm.controls.quantity.value;

            if(!this.packaging.id){
                this.isSaving = false;
                this.toast.error(`No se ha encontrado el id del paquete`);
                return;
            }

            const updatedPackagings: PackagingDto[] = await this.packagingsService.updatePackagingsQuantity([this.packaging]);

            this.isSaving = false;
            this.toast.success(`Cantidad del formato actualizada correctamente`);

            this.emitService.emit(updatedPackagings[0]);
            this.modalRef.close();
        } catch (e: unknown) {
            this.isSaving = false;
            if (e instanceof Error) {
                this.toast.error(e.message);
            }
        }
    }

    handleCancel() {
        this.modalRef.close();
    }
}
